
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBacklightLow as ObiBacklightLowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-backlight-low.js';
 
 
 

 
 export const ObiBacklightLow = createComponent({
   react: React,
   tagName: 'obi-backlight-low',
   elementClass: ObiBacklightLowElement,
   events: {
     
   }
  });
 
 